<!--<nav class="site-menu bg-white shadow-sm py-4">-->
<!--  <ul class="flex flex-wrap items-center justify-center space-x-6 md:space-x-10">-->
<!--    <li *ngFor="let category of families" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }" class="relative group">-->
<!--      <a [routerLink]="['/listP', category]" class="nav-link block py-3 text-gray-900 hover:text-red-600 transition-all duration-300">-->
<!--        <span class="uppercase text-base font-serif tracking-wider shadow-text">{{ category }}</span>-->
<!--      </a>-->
<!--      &lt;!&ndash; Active state gradient underline &ndash;&gt;-->
<!--&lt;!&ndash;-->
<!--      <div class="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-red-600 transform scale-x-0 transition-transform duration-300 origin-left group-[.active]:scale-x-100"></div>-->
<!--&ndash;&gt;-->
<!--    </li>-->
<!--    <li *ngIf="user && user?.roles?.admin" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }" class="relative group">-->
<!--      <a routerLink="/admin/add" class="nav-link block py-3 text-gray-900 hover:text-red-600 transition-all duration-300">-->
<!--        <span class="uppercase text-base font-serif tracking-wider shadow-text">Ajouter un produit</span>-->
<!--      </a>-->
<!--      <div class="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-red-600 transform scale-x-0 transition-transform duration-300 origin-left group-[.active]:scale-x-100"></div>-->
<!--    </li>-->
<!--  </ul>-->
<!--</nav>-->


<nav
  [ngClass]="{'hidden lg:block': !isMobileMenuOpen, 'block': isMobileMenuOpen}"
><ul
    class="container mx-auto px-2 sm:px-4 flex flex-col lg:flex-row items-center justify-center space-y-2 lg:space-y-0 lg:space-x-4 xl:space-x-6"
  >
    <li
      *ngFor="let category of families"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      class="relative group w-full lg:w-auto text-center"
    >
      <a
        [routerLink]="['/listP', category]"
        class="nav-link block py-2 sm:py-3 text-gray-900 hover:text-red-600 transition-all duration-300"
      >
        <span class="uppercase text-sm sm:text-base font-serif tracking-wider shadow-text">
          {{ category | uppercase }}
        </span>
      </a>
      <div
        class="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-red-600 transform scale-x-0 transition-transform duration-300 origin-left group-[.active]:scale-x-100"
      ></div>
    </li>
    <li
      *ngIf="user && user?.roles?.admin"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: false }"
      class="relative group w-full lg:w-auto text-center"
    >
      <a
        routerLink="/admin/add"
        class="nav-link block py-2 sm:py-3 text-gray-900 hover:text-red-600 transition-all duration-300"
      >
        <span class="uppercase text-sm sm:text-base font-serif tracking-wider shadow-text">
          Ajouter un produit
        </span>
      </a>
      <div
        class="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-red-600 transform scale-x-0 transition-transform duration-300 origin-left group-[.active]:scale-x-100"
      ></div>
    </li>
  </ul>
</nav>
